<template>
    <v-dialog v-model="isDialogOpen" persistent max-width="350">
        <v-card>
            <v-card-text>
                <h1 class="title-dialog-two-options">
                    Eliminar Artículo
                </h1>
                <p class="txt-dialog-two-options">
                    ¿Deseas eliminar el artículo <strong>{{name}}</strong> del registro? No podrás deshacer la acción.
                </p>
            </v-card-text>
            <v-card-actions style="display: flex; flex-direction: column;">
                <v-btn
                    class="btn-action-delete-stoke"
                    rounded="xl"
                    color="#FFFFFF"
                    :loading="isSavingData"
                    @click="okBtn">
                    Eliminar artículos
                </v-btn>
                <v-btn class="btn-dialog-two-options" color="#707070" @click="isDialogOpen = false">
                    Cerrar sin cambios
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import stockApi from '@/api/stockApi'
export default {
  name: 'CommerciaVueDialogDeleteStock',
  emits: ['saveOK'],
  data () {
    return {
      isDialogOpen: false,
      isSavingData: false,
      name: '',
      id: ''
    }
  },
  methods: {
    open (id, name) {
      this.id = id
      this.name = name
      this.isDialogOpen = true
    },
    async okBtn () {
      this.isSavingData = true
      const dataSave = await stockApi.delete(this.id)
      if (dataSave) {
        this.$emit('saveOK')
        this.isDialogOpen = false
      }
      this.isSavingData = false
    }
  }
}
</script>

<style scoped>
    .btn-action-delete-stoke{
        background-color: #FF5700;
        width: 200px;
        margin-bottom: 20px;
    }
    .title-dialog-two-options{
        width: 100%;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
    }
    .txt-dialog-two-options{
        width: 100%;
        text-align: center;
        font-size: 16px;
    }
    .btn-dialog-two-options{
        width: 49%;
    }
</style>
